import R from "ramda";
import deepmerge from "deepmerge";

const getSlugArray = x => x.substring(1, x.length - 1).split("/");

const getSlug = x => x.node.fields.slug;

const getParent = (a, i) => {
  return i - 1 < 0 || i + 1 === a.length ? null : a[i - 1];
};

const createSlug = (a, i) => {
  return i - 1 < 0
    ? `/${a[i]}`
    : "/" +
        a.reduce((p, c, j) => {
          return j <= i ? p + `${c}/` : p;
        }, "");
};

const getOrder = name => {
  const number = /\d+/.exec(name) ? Number(/\d+/.exec(name)[0]) - 1 : null;
  return number;
};

const getChildren = function getChildren(i, a) {
  if (i < a.length - 1) {
    return {
      name: a[i + 1],
      order: getOrder(a[i + 1]),
      parent: getParent(a, i + 1),
      slug: createSlug(a, i + 1),
      depth: i,
      children: i + 1 < a.length - 1 ? [getChildren(i + 1, a)] : []
    };
  } else if (i > 0) {
    return;
  }
  return {
    name: a[i],
    order: getOrder(a[i]),
    parent: getParent(a, i),
    slug: createSlug(a, i),
    depth: i,
    children: []
  };
};

const createIndexedObjs = x => {
  return x.reduce((p, c, i, a) => {
    if (i > 0) {
      return p;
    }
    p[c] = {
      name: c,
      order: getOrder(c),
      parent: getParent(a, i),
      slug: createSlug(a, i),
      depth: i,
      children: i < a.length - 1 ? [getChildren(i, a)] : []
    };
    return p;
  }, {});
};

const createObjs = R.map(
  R.pipe(
    getSlug,
    getSlugArray,
    createIndexedObjs
  )
);

const mergeChildren = function mergeChildren(x) {
  let newArr = [];
  for (let i = 0; i < x.length; i++) {
    if (i == 0) {
      newArr.push(x[i]);
    }
    if (i > 0) {
      if (x[i].name === newArr[newArr.length - 1].name) {
        newArr[newArr.length - 1].children.push(x[i].children[0]);
      } else if (x[i].name !== newArr[newArr.length - 1].name) {
        newArr.push(x[i]);
      }
    }
  }
  for (let i = 0; i < newArr.length; i++) {
    if (newArr[i].children.length > 0) {
      newArr[i].children = mergeChildren(newArr[i].children);
    }
  }
  return newArr;
};

export default x => {
  const navObj = deepmerge.all(createObjs(x));
  const objKeys = Object.keys(navObj);
  for (let i = 0; i < objKeys.length; i++) {
    navObj[objKeys[i]].children = mergeChildren(navObj[objKeys[i]].children);
  }
  return navObj;
};



// WEBPACK FOOTER //
// ./src/utils/createNavObj.js